<template>
	<div id="app">
		<section class="survey-container">
			<div class="steps-holder">
				<b-steps
					v-model="activeStep"
					:animated="isAnimated"
					:rounded="isRounded"
					:has-navigation="hasNavigation"
					:icon-prev="prevIcon"
					:icon-next="nextIcon"
					:label-position="labelPosition"
					:mobile-mode="mobileMode"
					@change="currentStep"
				>
					<b-step-item step="1" label :clickable="isStepsClickable">
						<Step1 @onStepSet="setFullField" />
					</b-step-item>
					<b-step-item step="2" label :clickable="isStepsClickable">
						<Step2 @onStepSet="setFullField" />
					</b-step-item>
					<b-step-item step="3" label :clickable="isStepsClickable">
						<Step3 @onStepSet="setFullField" />
					</b-step-item>
					<b-step-item step="4" label :clickable="isStepsClickable">
						<Step4 />
					</b-step-item>

					<template v-if="customNavigation" slot="navigation" slot-scope="{previous, next}">
						<div class="custom-nav-button">
							<b-button
								v-if="activeStep !== 3"
								:style="activeStep !== 0 && activeStep !== 3 ? '' : 'opacity: 0; visibility: hidden;'"
								outlined
								type="is-prev"
								icon-pack="sgi"
								icon-right="sgi-arrow-left"
								:disabled="previous.disabled"
								@click.prevent="previous.action"
							></b-button>
							<b-button
								v-if="activeStep !== 3"
								:type="!navNextDisabled ? 'is-next step-valid' : 'is-next'"
								icon-pack="sgi"
								:icon-right="activeStep === 2 ? 'sgi-circle-tick' : 'sgi-arrow-right'"
								:disabled="navNextDisabled ? navNextDisabled : next.disabled"
								@click.prevent="next.action"
							/>
						</div>
					</template>
				</b-steps>
			</div>
		</section>
	</div>
</template>

<script>
import Step1 from "./components/surveyStep1.vue";
import Step2 from "./components/surveyStep2.vue";
import Step3 from "./components/surveyStep3.vue";
import Step4 from "./components/surveyStep4.vue";

export default {
	name: "App",
	components: {
		Step1,
		Step2,
		Step3,
		Step4
	},
	data() {
		return {
			activeStep: 0,
			prevStep: 0,

			showSocial: false,
			isAnimated: true,
			isRounded: true,
			isStepsClickable: false,

			hasNavigation: true,
			customNavigation: true,
			isProfileSuccess: false,

			prevIcon: "chevron-left",
			nextIcon: "chevron-right",
			labelPosition: "bottom",
			mobileMode: "minimalist",

			currencySelected: "",

			fullData: {},
			navNextDisabled: true
		};
	},
	methods: {
		backtoFirst() {
			this.activeStep = 0;
		},
		setFullField(stepFields) {
			//console.log("Step Fields --->", stepFields);
			if (
				Object.prototype.hasOwnProperty.call(stepFields, "message") &&
				stepFields.message === ""
			) {
				this.fullData = { ...this.fullData, ...stepFields };
				this.navNextDisabled = false;
			} else {
				if (Object.values(stepFields).every(o => o !== null && o !== "")) {
					this.fullData = { ...this.fullData, ...stepFields };
					this.navNextDisabled = false;
				} else {
					this.navNextDisabled = true;
				}
			}
		},
		// Check Step
		checkStep(stepPos) {
			//console.log(this.prevStep, stepPos);
			if (this.prevStep < stepPos) {
				this.prevStep = stepPos - 1;
				if (stepPos === 2) {
					this.navNextDisabled = false;
				} else {
					this.navNextDisabled = true;
				}
			} else {
				this.navNextDisabled = false;
			}
		},
		// Check current step
		currentStep(stepPos) {
			switch (stepPos) {
				case 0:
					this.checkStep(stepPos);
					break;
				case 1:
					this.checkStep(stepPos);
					break;
				case 2:
					this.checkStep(stepPos);
					break;
				case 3:
					console.log("full data ----> ", this.fullData);
					this.sendData();
					break;

				default:
					break;
			}
		},
		sendData() {
			let data = new URLSearchParams({
				action: "partner_submit_action",
				_wpnonce: window.survey_nonce,
				partner_data: JSON.stringify(this.fullData)
			});
			fetch(window.ajaxurl, {
				method: "POST",
				credentials: "same-origin",
				headers: {
					"Content-Type": "application/x-www-form-urlencoded",
					"Cache-Control": "no-cache"
				},
				body: data
			})
				.then(response => response.json())
				.then(result => {
					if (result.success) {
						console.warn("Form sent.", result);
					} else {
						console.error("Form not sent.", result);
					}
				})
				.catch(error => {
					console.error("Form not sent.", error);
				});
		}
	}
};
</script>

<style lang="scss">
#app {
	font-family: Avenir, Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	text-align: center;
	color: #2c3e50;

	.survey-container {
		display: grid;
		grid-template-columns: 1fr;

		@include for-phone-only {
			display: block;
		}
		.steps-holder {
			width: 100%;
			height: 100%;

			.b-tooltip {
				display: block;
			}

			.b-steps {
				position: relative;
				display: flex;
				flex-wrap: wrap;
				height: 100%;
				align-items: center;
				justify-content: center;

				nav.steps {
					flex-basis: 100%;
					width: 50%;
					margin: 0;

					.step-items {
						width: 30%;

						.step-item {
							&:before {
								display: none !important;
							}
							&.is-previous,
							&.is-active {
								.step-marker {
									background-color: $primary;
									color: $primary;
								}
							}
						}
						.step-marker {
							background: rgba(144, 168, 190, 0.3);
							width: 20px;
							height: 20px;
							span {
								display: none;
							}
						}
					}

					@include for-phone-only {
						width: 90% !important;
						margin: 0 auto !important;
					}
				}
				.step-content {
					flex-basis: 70%;
					width: 100%;

					h5 {
						margin-bottom: 20px;
						text-align: left;
						color: #90a8be !important;
					}

					@include for-phone-only {
						margin-top: 36px;
						padding-bottom: 120px;
					}
				}
				.custom-nav-button {
					flex-basis: 30%;
				}
				.step-navigation,
				.custom-nav-button {
					display: flex;
					justify-content: space-between;
					align-self: flex-end;

					button {
						display: flex !important;
						justify-content: center !important;
						align-items: center !important;
						height: 100% !important;
						border-radius: 10px !important;
						width: 75px;
						height: 75px !important;

						i {
							font-size: 25px;
						}
					}

					.is-prev {
						position: absolute;
						left: 14px;
						bottom: -54px;
						height: 36px !important;
						margin-left: 0;
						padding: 5px 18px !important;
						color: $primary !important;
						border-color: #ff790e;
						transition: all 0.3s ease;

						span.icon {
							color: $primary !important;
						}

						@include for-phone-only {
							margin-left: 3vw;
						}
					}
					.is-next {
						background: linear-gradient(to right, #ff790e, #ec547a);
						margin-right: 1.25vw;
						margin-top: 5px;
						margin-bottom: 1rem;
						color: $primary;
						border-color: $primary;
						transition: all 0.3s ease;

						&.step-valid {
							background-color: $primary;
							color: #fff;
						}

						i {
							color: #fff;
						}

						span.icon.is-small {
							i.sgi.sgi-circle-tick {
								font-weight: 700;
							}
						}

						@include for-phone-only {
							margin-right: 3vw;
						}

						span {
							font-size: 14px !important;

							@include for-phone-only {
								&:first-of-type {
									display: none;
								}
								&.icon.is-small {
									margin: 0 !important;
								}
							}
						}

						&:not(:disabled):hover {
							color: #fff;
							background: linear-gradient(to right, #ff790e, #ec547a);
						}
					}
				}
			}
		}
	}
}
</style>
